import { BackgroundJobType } from 'types/graphql'

/** Originating records-list view for header pill navigation. */
export type BackgroundJobPillNavigationContextRecords = {
  type: 'BulkCloseRecords' | 'BulkReassignRecords'
  viewId: number
  recordTypeId: number
}

/** Originating inspections-list view for header pill navigation. */
export type BackgroundJobPillNavigationContextInspections = {
  type: 'BulkReassignInspections'
  viewId: number
  recordTypeId: number
}

/** Originating tasks-list view for header pill navigation (org-wide; no recordTypeId). */
export type BackgroundJobPillNavigationContextTasks = {
  type: 'BulkReassignTasks'
  viewId: number
}

export type BackgroundJobPillNavigationContext =
  | BackgroundJobPillNavigationContextRecords
  | BackgroundJobPillNavigationContextInspections
  | BackgroundJobPillNavigationContextTasks

export const hasBackgroundJobPillNavigationContext = (backgroundJob: {
  type: BackgroundJobType
  viewId?: number | null
  recordTypeId?: number | null
}): backgroundJob is BackgroundJobPillNavigationContext & {
  viewId: number
  recordTypeId?: number | null
} => {
  if (backgroundJob.viewId == null) {
    return false
  }

  if (backgroundJob.type === 'BulkReassignTasks') {
    return true
  }

  if (
    backgroundJob.type === 'BulkCloseRecords' ||
    backgroundJob.type === 'BulkReassignRecords' ||
    backgroundJob.type === 'BulkReassignInspections'
  ) {
    return backgroundJob.recordTypeId != null
  }

  return false
}
